module.exports = __webpack_public_path__ + "img/IMG_6258_L_BlackMatted_MockedUp.54c19876.jpg";